/* eslint-disable no-param-reassign */
import { PayloadAction } from "@reduxjs/toolkit"

import { ProjectsReducerState } from "./types"

function initializeProjectState(
  projectID: string,
  state: ProjectsReducerState
) {
  if (!state[projectID]) {
    state[projectID] = {
      isPending: false
    }
  }
}

export function setProjectPendingHandler(
  state: ProjectsReducerState,
  action: PayloadAction<{ projectID: string }>
) {
  const { projectID } = action.payload
  initializeProjectState(projectID, state)
  state[projectID].isPending = true
}

export function unsetProjectPendingHandler(
  state: ProjectsReducerState,
  action: PayloadAction<{ projectID: string }>
) {
  const { projectID } = action.payload
  initializeProjectState(projectID, state)
  state[projectID].isPending = false
}
